import {
  registerComponent,
  getComponentConfig,
  debounce,
  asyncRequest,
  replaceDOM,
  loading,
} from "helpers";

registerComponent(
  "product-options",
  class ProductOptions extends HTMLElement {
    // "*" will be replaced with product id
    ELEMENTS_TO_REPLACE = [
      '[data-product-media="*"]',
      '[data-product-prices="*"]',
      '[data-add-to-cart="*"]',
      '[data-inventory-messaging="*"]',
      '[data-sku-display="*"]',
      '[data-product-options="*"]',
      '[data-product-availability="*"]',
      '[data-additional-info="*"]',
      '[data-why-bambi-baby="*"]',
    ];

    constructor() {
      super();

      this.config = getComponentConfig(this);
      this.options = this.querySelectorAll("[data-product-option]");
      this.selectedOptions = this.getSelectedOptions();
      [this.productPath, this.productParams] = this.config.url.split("?");
      this.isPDP = window.location.pathname === this.productPath;

      const debouncedHandler = debounce((event) => {
        this.handleOptionChange(event);
      }, 300);

      this.options.forEach((option) => {
        option.addEventListener("change", debouncedHandler.bind(this));
      });
    }

    handleOptionChange(event) {
      const productUrl = event.target.dataset.productUrl;
      loading.add(this);

      if (productUrl) {
        this.updateProductDOM(productUrl);
      } else {
        this.selectedOptions = this.getSelectedOptions();
        this.updateProductDOM();
      }
    }

    getSelectedOptions() {
      const checkedInputs = Array.from(
        this.querySelectorAll("[data-product-option]:checked")
      );

      return checkedInputs.map((input) => input.dataset.productOption);
    }

    async updateProductDOM(productUrl) {
      const url = productUrl ? productUrl : this.getURL();
      const response = await asyncRequest(url);

      if (response) {
        this.handleSuccessfulUpdate(response, productUrl);
      } else {
        this.handleUnsuccessfulUpdate(productUrl);
      }

      loading.remove(this);
    }

    handleSuccessfulUpdate(html, productUrl) {
      const url = productUrl ? productUrl : this.getURL();

      if (this.isPDP) {
        window.scrollTo({
          top: 0,
        });
      }

      if (productUrl) {
        document.documentElement.innerHTML = html;
      } else {
        this.ELEMENTS_TO_REPLACE.forEach((selector) => {
          const DOMspecificPlaceholder = selector.replace(
            "*",
            this.config.product.id
          );

          replaceDOM(html, DOMspecificPlaceholder);
        });
      }

      if (this.isPDP) {
        window.history.replaceState(null, "", url);
      }
    }

    handleUnsuccessfulUpdate(productUrl) {
      if (this.isPDP) {
        if (productUrl) {
          window.location.href = productUrl;
        } else {
          window.location.href = this.getURL();
        }
      }
    }

    getURL() {
      const params = window.location.search;
      const search = new URLSearchParams(params);

      search.set("option_values", this.selectedOptions.join(","));

      return `${window.location.origin}${this.config.url}?${search.toString()}`;
    }
  }
);
